import ArrowLeft from "react-feather/dist/icons/arrow-left";
import ArrowRight from "react-feather/dist/icons/arrow-right";
import classnames from "classnames";

import style from "./style.module.scss";
import type { ArrowSelectorProps } from "../../types";

function ArrowSelector<T = string>({
  value,
  options,
  onChange,
  classNames = {},
  renderLabel = (label) => label,
}: ArrowSelectorProps<T>) {
  const selectedOption = options.find((option) => option.value === value) || options[0];
  const index = options.indexOf(selectedOption);
  const onNext = () => {
    const next = options[(index + 1) % options.length];
    onChange(next.value);
  };
  const onPrevious = () => {
    const previous = options[index === 0 ? options.length - 1 : index - 1];
    onChange(previous.value);
  };

  return (
    <div className={style.selector}>
      <button type="button" className={classnames(style.label, classNames.label)} onClick={onNext}>
        {renderLabel(selectedOption.label)}
      </button>
      <button type="button" className={style.arrow} onClick={onPrevious}>
        <ArrowLeft />
      </button>
      <button type="button" className={style.arrow} onClick={onNext}>
        <ArrowRight />
      </button>
    </div>
  );
}

export default ArrowSelector;
